"use client";
import * as React from "react";
import styles from "./UseCases.module.css";
import UseCaseCard from "./UseCaseCard";


function UseCases({useCases}) {  
  return (
    <main className={styles.useCases}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <h1 className={styles.headerTitle}>Use Cases</h1>
        </div>
      </header>

      <section className={styles.mainContent}>
        {useCases.map((useCase, index) => (
          <UseCaseCard
            key={useCase.id || index}
            title={useCase.title}
            description={useCase.description}
            imageSrc={useCase.image_url}
            video_url={useCase.video_url}
            imagePosition={index % 2 === 0 ? "right" : "left"}
            isFirst={index === 0}
            mode={useCase.mode}
          />
        ))}
      </section>
    </main>
  );
}

export default UseCases;
